import React from 'react';
import clsx from 'clsx';

import './FilterRequestPanel.css';
import { useProductContext } from 'hooks/product/useProductContext';
import Button from 'components/button/Button';
import Dialog from 'components/dialog/Dialog';
import Tooltip from 'components/tooltip/Tooltip';
import SupplierRequests from 'components/panel/search/requests/SupplierRequests';

//
// --- Types ---

export interface FilterRequestPanelProps {
  className?: string;
}

//
// --- Helpers ---

function getRequestTooltipTitle(personCount: number): string {
  if (!personCount) {
    return 'No Supplier Requests';
  }

  return personCount === 1 ? 'There is 1 pending request.' : `There are ${personCount} pending requests.`;
}

//
// --- FilterRequestPanel Component ---

const FilterRequestPanel: React.FC<FilterRequestPanelProps> = ({ className }) => {
  const [showRequestDialog, setShowRequestDialog] = React.useState<boolean>(true);
  const [{ sourcing }] = useProductContext();

  const { bidTeams, supplierRequestPersonCount, supplierRequests } = sourcing;
  const hasRequests = supplierRequestPersonCount > 0;

  return (
    <div className={clsx('filter-request-panel', className)} data-testid="filter-request-panel">
      <Tooltip className="filter-request-panel-tooltip" title={getRequestTooltipTitle(supplierRequestPersonCount)}>
        {/** extra div needed to work-around "Material-UI: providing a disabled `button` child to the Tooltip" message */}
        <div>
          <Button
            color={hasRequests ? 'primary' : 'default'}
            className="filter-request-panel-request-button"
            disabled={!hasRequests}
            onClick={() => setShowRequestDialog(true)}
            fullWidth
          >
            {hasRequests ? `View Requests (${supplierRequestPersonCount})` : 'No New Requests'}
          </Button>
        </div>
      </Tooltip>
      {hasRequests && (
        <Dialog
          className="filter-request-panel-request-dialog"
          content={<SupplierRequests bidTeams={bidTeams} supplierRequestsTree={supplierRequests} />}
          onClose={() => setShowRequestDialog(false)}
          onCloseButtonClick={() => setShowRequestDialog(false)}
          open={showRequestDialog}
          title="Supplier Requests"
          showCloseButton
        />
      )}
    </div>
  );
};

export default FilterRequestPanel;
